import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { BathroomCount } from 'domain/listing/value-objects';
import { Namespaces } from 'types/locales';
import { formatBathroomCount, type BathroomCountFormat } from './format-bathroom-count';

export interface UseBathroomCountOptions {
  bathrooms: number | null;
  format?: BathroomCountFormat;
}

export interface UseBathroomCountResult {
  formatted: string;
  hasValue: boolean;
}

export function useBathroomCount(options: UseBathroomCountOptions): UseBathroomCountResult {
  const { bathrooms, format = 'short' } = options;
  const { t } = useTranslation(Namespaces.COMMON);

  return useMemo(() => {
    const vo = BathroomCount.from(bathrooms);
    return {
      formatted: formatBathroomCount(vo, format, t),
      hasValue: vo.hasValue,
    };
  }, [bathrooms, format, t]);
}
